import {
  SET_ORDERING_EVENT_ID,
  SET_IS_PREVIEW,
  SET_ACTIVE_CART_LOCATION_SLUG,
  SET_ACTIVE_SECTION,
} from './ConsumerActions';

const initialState = {
  activeCartLocationSlug: null,
  activeSection: null,
  isPreview: false,
  orderingEventId: null,
};

const ConsumerReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ORDERING_EVENT_ID:
      return {
        ...state,
        orderingEventId: action.orderingEventId,
      };
    case SET_IS_PREVIEW:
      return {
        ...state,
        isPreview: true,
      };
    case SET_ACTIVE_CART_LOCATION_SLUG:
      return {
        ...state,
        activeCartLocationSlug: action.activeCartLocationSlug,
      };
    case SET_ACTIVE_SECTION:
      return {
        ...state,
        activeSection: action.activeSection,
      };
    default:
      return state;
  }
};

export default ConsumerReducer;
